import httpManager from "@/app/shared/utils/httpManager";
/**
 * Obtener descarga realizas por el usuario
 * @return {Promise<Object>} descarga.
 */
export async function fetchPortfolioResultsNC(portfolioId: number) {
  const response = await httpManager.get(`entities/portfolios/${portfolioId}/results-nc/`);
  return response.data;
}
